import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

/**
 * Light-blue section header strip used on Overview and similar dashboards.
 * Matches Vera Web/App: navy title, optional count chip, optional "See all" link.
 */
export default function SectionHeader({
  title,
  count,
  seeAllText,
  seeAllLinkProps,
  action,
  className,
}: {
  title: string;
  count?: number;
  seeAllText?: string;
  seeAllLinkProps?: Omit<LinkProps, 'children'>;
  action?: React.ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={twMerge(
        'flex items-center justify-between gap-3 rounded-t-[12px] bg-primary-100 px-4 py-2.5',
        className,
      )}>
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-primary-900">{title}</h3>
        {count !== undefined && (
          <span className="inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-surface px-1.5 text-xs font-semibold text-primary-900">
            {count}
          </span>
        )}
      </div>
      <div className="flex items-center gap-3">
        {action}
        {seeAllLinkProps && seeAllText && (
          <Link
            {...seeAllLinkProps}
            className="text-sm font-medium text-primary hover:underline">
            {seeAllText}
          </Link>
        )}
      </div>
    </div>
  );
}
